import { createSlice } from '@reduxjs/toolkit';
import { setIsLoading } from '../Loader/LoaderSlice';
import { setApiError } from '../Error/ErrorSlice';
import { fireApi } from '../../../utils/FireApi';
import { OnboardingApi } from '../../../utils/Apis';
import { resetStore } from '../../Actions';

const initialState = {
  list_data: null,
  view_data: null,
  commission_data: null,
  hierarchy_user: null,
  reporting_manager_list: null,
  reporting_manager_list2: null
};

const OnboardingSlice = createSlice({
  name: 'Onboarding',
  initialState,
  reducers: {
    setOnboardingGrid(state, action) {
      state.list_data = action.payload;
    },
    setOnboardingView(state, action) {
      state.view_data = action.payload;
    },
    setShowCommission(state, action) {
      state.commission_data = action.payload;
    },
    setHierarchyUserLevelGrid(state, action) {
      state.hierarchy_user = action.payload;
    },
    setReportingManagerList(state, action) {
      state.reporting_manager_list = action.payload;
    },
    setReportingManagerList2(state, action) {
      state.reporting_manager_list2 = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(resetStore, () => initialState); // clear store
  }
});

// Onboarding List
export const getOnboardingsList = (data) => async (dispatch) => {
  dispatch(setIsLoading({ loading: true }));
  try {
    const res = await fireApi({
      endpoint: OnboardingApi?.onboardingList,
      method: 'post',
      payload: data
    });

    // 🔹 Handle success
    if (res?.success) {
      dispatch(setOnboardingGrid(res?.data?.data ? res?.data?.data : res?.data)); // store in redux
      return res?.data;
    } else {
      dispatch(setOnboardingGrid(null)); // store in redux
      dispatch(setApiError(res?.message || 'Something went wrong'));
      console.error('❌ Onboarding List failed rrrrr', res?.data?.error);
      return null;
    }
  } catch (error) {
    dispatch(setApiError('Something went wrong'));
    console.error('🔥 Onboarding List exception rrrrr', error);
    return null;
  } finally {
    dispatch(setIsLoading({ loading: false }));
  }
};

export const VerifyFileData = (endpoint, data, token) => async (dispatch) => {
  dispatch(setIsLoading({ loading: true }));

  try {
    const formBody = new URLSearchParams();
    formBody.append('otp', data.otp);
    formBody.append('ref_id', data.ref_id);
    formBody.append('client_id', data.client_id);
    formBody.append('userId', data.userId);

    const res = await fireApi({
      endpoint,
      method: 'post',
      payload: formBody.toString(), // 👈 IMPORTANT
      extraHeaders: {
        'Content-Type': 'application/x-www-form-urlencoded'
        // Authorization: `Bearer ${token}`
      }
    });

    if (res?.success) {
      dispatch(setApiError('Data uploaded successfully !'));
      return res;
    } else {
      dispatch(setApiError(res?.message || res?.error || 'Something went wrong'));
      return null;
    }
  } catch (error) {
    dispatch(setApiError('Something went wrong'));
    return null;
  } finally {
    dispatch(setIsLoading({ loading: false }));
  }
};

// Onboarding View
export const getOnboardingView = (data) => async (dispatch) => {
  dispatch(setIsLoading({ loading: true }));
  try {
    const res = await fireApi({
      endpoint: OnboardingApi?.onboardReview,
      method: 'post',
      payload: data
    });

    // 🔹 Handle success
    if (res?.success) {
      dispatch(setOnboardingView(res?.data?.data ? res?.data?.data : res?.data)); // store in redux
      return res?.data;
    } else {
      dispatch(setOnboardingView(null)); // store in redux
      dispatch(setApiError(res?.message || 'Something went wrong'));
      console.error('❌ Onboarding View failed rrrrr', res?.data?.error);
      return null;
    }
  } catch (error) {
    dispatch(setApiError('Something went wrong'));
    console.error('🔥 Onboarding View exception rrrrr', error);
    return null;
  } finally {
    dispatch(setIsLoading({ loading: false }));
  }
};

// Onboarding show Commision
export const getOnboardingShowData = (data) => async (dispatch) => {
  dispatch(setIsLoading({ loading: true }));
  try {
    const res = await fireApi({
      endpoint: OnboardingApi?.onboardCommissionList,
      method: 'post',
      payload: data
    });

    // 🔹 Handle success
    if (res?.success) {
      dispatch(setShowCommission(res?.data?.data ? res?.data?.data : res?.data)); // store in redux
      return res?.data;
    } else {
      dispatch(setShowCommission(null)); // store in redux
      dispatch(setApiError(res?.message || 'Something went wrong'));
      console.error('❌ Onboarding show Commision failed rrrrr', res?.data?.error);
      return null;
    }
  } catch (error) {
    dispatch(setApiError('Something went wrong'));
    console.error('🔥 Onboarding show Commision exception rrrrr', error);
    return null;
  } finally {
    dispatch(setIsLoading({ loading: false }));
  }
};

// hierarchy user level

export const getHierarchyUserLevelList =
  ({ partnerId }) =>
  async (dispatch) => {
    dispatch(setIsLoading({ loading: true }));
    try {
      const res = await fireApi({
        endpoint: `${OnboardingApi?.hierarchyUserLevel}${partnerId}`,
        method: 'get',
        payload: { partnerId }
      });
      console.log('sss hierarchyUserLevel', res);
      // 🔹 Handle success
      if (res?.success) {
        dispatch(setHierarchyUserLevelGrid(res?.data?.data ? res?.data?.data : res?.data)); // store in redux
        return res?.data;
      } else {
        dispatch(setHierarchyUserLevelGrid(null)); // store in redux
        dispatch(setApiError(res?.message || 'Something went wrong'));
        console.error('❌ hierarchyUserLevel List failed ', res?.data?.error);
        return null;
      }
    } catch (error) {
      dispatch(setApiError('Something went wrong'));
      console.error('🔥 hierarchyUserLevel List exception ', error);
      return null;
    } finally {
      dispatch(setIsLoading({ loading: false }));
    }
  };

export const getReportingManagerList = (data) => async (dispatch) => {
  dispatch(setIsLoading({ loading: true }));
  console.log('sss endpoint', `${OnboardingApi?.reportingManagerList}${data?.cityId}`);
  try {
    const res = await fireApi({
      endpoint: `${OnboardingApi?.reportingManagerList}${data?.cityId}`,
      method: 'get',
      payload: data
    });
    console.log('sss reportingManagerList', res);
    // 🔹 Handle success
    if (res?.success) {
      dispatch(setReportingManagerList(res?.data?.data ? res?.data?.data : res?.data)); // store in redux
      return res?.data;
    } else {
      dispatch(setReportingManagerList(null)); // store in redux
      dispatch(setApiError(res?.message || 'Something went wrong'));
      console.error('❌ Onboarding List failed rrrrr', res?.data?.error);
      return null;
    }
  } catch (error) {
    dispatch(setApiError('Something went wrong'));
    console.error('🔥 Onboarding List exception rrrrr', error);
    return null;
  } finally {
    dispatch(setIsLoading({ loading: false }));
  }
};
export const getReportingManagerList2 = (data) => async (dispatch) => {
  dispatch(setIsLoading({ loading: true }));
  console.log('sss endpoint', `${OnboardingApi?.reportingManagerList2}/${data?.userId}`);
  try {
    const res = await fireApi({
      endpoint: `${OnboardingApi?.reportingManagerList2}/${data?.userId}`,
      method: 'get',
      payload: data
    });
    console.log('sss reportingManagerList2', res);
    // 🔹 Handle success
    if (res?.success) {
      dispatch(setReportingManagerList2(res?.data?.data ? res?.data?.data : res?.data)); // store in redux
      return res?.data;
    } else {
      dispatch(setReportingManagerList2(null)); // store in redux
      dispatch(setApiError(res?.message || 'Something went wrong'));
      console.error('❌ Onboarding List failed rrrrr', res?.data?.error);
      return null;
    }
  } catch (error) {
    dispatch(setApiError('Something went wrong'));
    console.error('Onboarding List exception rrrrr', error);
    return null;
  } finally {
    dispatch(setIsLoading({ loading: false }));
  }
};

export const {
  setOnboardingGrid,
  setOnboardingView,
  setShowCommission,
  setHierarchyUserLevelGrid,
  setReportingManagerList,
  setReportingManagerList2
} = OnboardingSlice.actions;
export default OnboardingSlice.reducer;
